import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExclamationMarkRounded = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 12,
		cy: 12,
		r: 11,
		stroke: "#C4C4C4",
		strokeWidth: 2
	}), /* @__PURE__ */ _jsx("path", {
		d: "M11.204 8.096H13.038V6.472H11.204V8.096ZM11.274 17H12.968V9.328H11.274V17Z",
		fill: "#C4C4C4"
	})]
});
export default SvgExclamationMarkRounded;
